<template>
  <div>
    <p>Vendedor: {{ commercialRelease.salesman && commercialRelease.salesman.name || purchaseOrder.user && purchaseOrder.user.name }}</p>
    <p>Cliente:  {{ commercialRelease.client && commercialRelease.client.razao_social || purchaseOrder.client && purchaseOrder.client.razao_social }}</p>
    <hr/>

    <div v-if="hasReason" id="commercial-release-reason">
      <h3>Justificativa</h3>
      <div v-if="purchaseOrder && purchaseOrder.pending_validations">
        <p
          v-for="validation in purchaseOrder.pending_validations"
          :key="validation"
          class="text-danger font-weight-bold"
        >
          {{ translateValidation(validation) }}
        </p>
      </div>
      <br>
      <div
        v-if="commercialRelease.reason || purchaseOrder.need_liberation_reason"
        id="additional-commercial-release-reason"
      >
        <h3>Complemento</h3>
        <p>{{ commercialRelease.reason || purchaseOrder.need_liberation_reason }}</p>
      </div>
      <hr/>
    </div>

    <h3 >Produtos</h3>
    <order-item-details
      v-loading="isLoadingOrderItems"
      v-for="order_item in orderItems"
      :key="order_item.id"
      :order-item="order_item"
    />

    <p style="text-align: right">
      Total:  {{ commercialRelease.value ? commercialRelease.value.toLocaleString("pt-BR", { style: "currency", currency: "brl" }) : currency.toLocaleString("pt-BR", { style: "currency", currency: "brl" })}}</p>
  </div>
</template>

<script>
import OrderItemDetails from "./OrderItemDetails";

var VALIDATION_TRANSLATIONS = {
  unit_value: 'Valor de pedido diferente do valor da tabela de preço selecionada.',
  max_discount: 'Desconto excede valor máximo definido.',
  authorized_salesman: 'Vendedor Informado diferente do configurado no parceiro/propriedade.'
}

export default {
  name: 'commercial-release-details',
  components: {
    OrderItemDetails,
  },
  props: {
    commercialRelease: Object,
    orderItems: Array,
    clientPurchaseValidations: Object,
    purchaseOrder: {
      type: Object,
      default: () => {
        return {};
      },
    }
  },
  data: () => ({
    localOrderItems: [],
    isLoadingOrderItems: false,
  }),
  mounted() {
    this.getOrderItems()
  },
  methods: {
    async getOrderItems() {
      this.isLoadingOrderItems = true
      if (!this.commercialRelease.purchase_order_id) {
        this.isLoadingOrderItems = false;
        return
      }
      const response = await this.$http.secured.get(`/api/v1/purchase_orders/${this.commercialRelease.purchase_order_id}/order_items`, { params: { unpaged: true } })
      this.localOrderItems = response.data || []
      this.isLoadingOrderItems = false;
    },
    translateValidation(validation) {
      return VALIDATION_TRANSLATIONS[validation] || validation
    }
  },
  computed: {
    currency: {
      get() {
        let sum = 0
        if(this.orderItems && this.orderItems.length > 0)  {
          this.orderItems.map(orderItem => {
            sum += orderItem.total_cost
          })
        }
        return sum
      }
    },
    hasReason() {
      return (this.commercialRelease && this.commercialRelease.reason) || (this.purchaseOrder && this.purchaseOrder.pending_validations && (this.purchaseOrder.pending_validations.length > 0))
    }
  }
}
</script>

<style scoped>
#additional-commercial-release-reason {
  white-space: pre-line;
}
</style>
